export type SurveyCompletionVariant = 'fresh' | 'alreadySubmitted'

/**
 * Logged-in return visits use already-submitted copy.
 * Guests who already submitted still need the claim / verify-mobile journey.
 */
export function resolveSurveyCompletionVariant(input: {
  justSubmitted: boolean
  guestClaimJourney: boolean
}): SurveyCompletionVariant {
  if (input.justSubmitted || input.guestClaimJourney) return 'fresh'
  return 'alreadySubmitted'
}
